import { ReimbursableSupplementTaxonomiesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface ReimbursableSupplementTaxonomyMapping {
  id: string
  legalEntityId: string
  reimbursableId: string
  reimbursableType: string
  supplementTaxonomyId: string
}

interface QueyResults {
  loading: boolean
  mappings: ReimbursableSupplementTaxonomyMapping[]
}

export function useFetchCustomTimeRangeCategorySupplementMappings(
  legalEntityIds: string[]
): QueyResults {
  const { data: mappings, loading } = useQuery(ReimbursableSupplementTaxonomiesDocument, {
    variables: {
      legalEntityIds: legalEntityIds,
      reimbursableTypes: ['TimeSettings::CustomTimeRangeCategory'],
    },
  })

  return {
    loading,
    mappings: mappings?.payroll.reimbursableSupplementTaxonomies ?? [],
  }
}
